import { Center } from '@zorro/web/design-system';

export const EvidenceFileIcon = () => {
  return (
    <Center>
      <svg
        width="35"
        height="32"
        viewBox="0 0 35 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.135 12.8814C18.0425 11.7062 20.0605 11.7062 20.968 12.8814L32.6102 27.9575C33.6175 29.2619 32.5226 31 30.6936 31H7.40936C5.58038 31 4.48554 29.2619 5.49283 27.9575L17.135 12.8814Z"
          fill="#F0E6FF"
        />
        <path
          d="M10.2734 30C13.9451 27.7778 16.4699 25.5556 16.4699 23.3333C16.4699 20 14.6798 20 13.5782 20C12.4766 20 11.7873 21.2056 11.8226 23.3333C11.86 25.6089 13.2015 26.53 14.129 27.7778C15.7814 30 16.883 30.5556 17.9846 28.8889C18.7194 27.7778 19.2702 26.8522 19.637 26.1111C20.7386 28.7033 22.2071 30 24.0434 30H26.7974"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.94439 2H5.99368C5.2111 2 4.46058 2.36875 3.90721 3.02513C3.35385 3.6815 3.04297 4.57174 3.04297 5.5V26.5C3.04297 27.4283 3.35385 28.3185 3.90721 28.9749C4.46058 29.6313 5.2111 30 5.99368 30H20.7472C21.5298 30 22.2803 29.6313 22.8337 28.9749C23.3871 28.3185 23.6979 27.4283 23.6979 26.5V5.5C23.6979 4.57174 23.3871 3.6815 22.8337 3.02513C22.2803 2.36875 21.5298 2 20.7472 2H8.94439Z"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.17188 7H19.5649"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M7.17188 12H19.5649"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M7.17188 17H19.5649"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </Center>
  );
};
